import { useQuery } from '@tanstack/react-query';

import { useHookInjection } from 'domain/hooks';
import { TournamentLeaderboardRepository, ITournamentLeaderboardRepository } from 'domain/repositories/ITournamentLeaderboardRepository';

export const TournamentLeaderboardKey = 'TournamentLeaderboard';

export const useCaseGetTournamentLeaderboard = (tournamentId: string) => {
  const { fetchTournamentLeaderboard } = useHookInjection<ITournamentLeaderboardRepository>(
    TournamentLeaderboardRepository,
  );

  const { data, error, isLoading } = useQuery({
    refetchInterval: 65000,
    enabled: !!tournamentId,
    retry: 3,
    queryKey: [TournamentLeaderboardKey, { tournamentId }],
    queryFn: () => fetchTournamentLeaderboard(tournamentId),
  });

  return { data: data ?? [], error, isLoading };
};
